{
  "version": 1,
  "asset_id": "83aeb765-ff4b-4fed-b3c1-f17225f07596",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/83aeb765-ff4b-4fed-b3c1-f17225f07596/cert-tsa.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/83aeb765-ff4b-4fed-b3c1-f17225f07596/cert-tsa.webp",
  "original_filename": "cert-tsa.webp",
  "size": 24788,
  "content_type": "image/webp",
  "created_at": "2026-09-22T12:30:28Z"
}
